export enum SearchSelector {
  Name = 'name',
  CountryAlpha3 = 'countries',
  EntityType = 'entityType',
  AltVfiEntityId = 'altVfiEntityId',
  TaxRegistrationNumber = 'taxRegistrationNumber',
  EntityId = 'entityUid',
  BusinessIdentifierValue = 'businessIdentifierValue',
  Status='status'
}
